import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './Context/UserContexts';
import { StyledEngineProvider } from '@mui/material';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <UserProvider>
      <StyledEngineProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </StyledEngineProvider>
    </UserProvider>
  </React.StrictMode>
);


